
<div class="min-h-screen bg-slate-900 flex items-center justify-center p-4">
    @if(currentStore(); as store) {
      <div class="max-w-md w-full bg-slate-800 rounded-2xl shadow-2xl overflow-hidden border border-slate-700 animate-fade-in-up">
        <div class="p-8">
          <div class="text-center mb-8">
            <div class="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg shadow-emerald-500/20">
              <i class="fa-solid fa-magic-wand text-3xl text-white"></i>
            </div>
            <h2 class="text-2xl font-bold text-white">ตั้งค่าร้านค้าของคุณ</h2>
            <p class="text-slate-400 mt-2 text-sm">กรุณาระบุข้อมูลเบื้องต้นเพื่อเริ่มต้นใช้งาน</p>
          </div>

          <form [formGroup]="onboardForm" (ngSubmit)="onSubmit()" class="space-y-6">
            
            <div>
                <label class="block text-sm font-medium text-slate-300 mb-2">ประเภทธุรกิจ (Business Type)</label>
                <div class="p-4 rounded-lg flex items-center gap-4" [class]="store.businessType === 'CLINIC' ? 'bg-blue-900/50 border border-blue-700' : 'bg-emerald-900/50 border border-emerald-700'">
                    @if(store.businessType === 'CLINIC') {
                        <i class="fa-solid fa-user-doctor text-3xl text-blue-300"></i>
                        <div>
                            <p class="font-bold text-white">คลินิก (Clinic)</p>
                            <p class="text-xs text-blue-300">คุณได้เลือกลงทะเบียนเป็นคลินิก</p>
                        </div>
                    } @else {
                        <i class="fa-solid fa-cannabis text-3xl text-emerald-300"></i>
                         <div>
                            <p class="font-bold text-white">ร้านยา (Dispensary)</p>
                            <p class="text-xs text-emerald-300">คุณได้เลือกลงทะเบียนเป็นร้านยา</p>
                        </div>
                    }
                </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">ชื่อร้าน / คลินิก</label>
              <input type="text" formControlName="storeName" placeholder="เช่น คลินิกเชื่อมกัญ สาขาทองหล่อ" 
                     class="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all">
              @if(onboardForm.get('storeName')?.touched && onboardForm.get('storeName')?.invalid) {
                <div class="text-red-400 text-xs mt-1">
                  กรุณาระบุชื่อร้าน
                </div>
              }
            </div>

            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">ตั้งรหัส PIN ส่วนตัว (6 หลัก)</label>
              <p class="text-xs text-slate-500 mb-2">ใช้สำหรับเข้าสู่ระบบ Kiosk ในฐานะเจ้าของร้าน</p>
              <input type="text" formControlName="ownerPin" placeholder="123456" maxlength="6"
                     class="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white font-mono text-center tracking-widest text-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all">
              @if(onboardForm.get('ownerPin')?.touched && onboardForm.get('ownerPin')?.invalid) {
                <div class="text-red-400 text-xs mt-1">
                  รหัส PIN ต้องเป็นตัวเลข 6 หลัก
                </div>
              }
            </div>

            @if(errorMessage()) {
              <div class="bg-red-900/50 border border-red-500 text-red-200 p-3 rounded-lg text-sm flex items-center gap-2">
                <i class="fa-solid fa-circle-exclamation"></i> {{ errorMessage() }}
              </div>
            }

            <button type="submit" [disabled]="onboardForm.invalid || isSubmitting()" 
                    class="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3.5 rounded-lg shadow-lg transition-all transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center gap-2">
                @if(isSubmitting()) {
                  <i class="fa-solid fa-spinner animate-spin"></i> กำลังบันทึก...
                } @else {
                  <span>เริ่มต้นใช้งาน</span> <i class="fa-solid fa-arrow-right"></i>
                }
            </button>

          </form>
        </div>
      </div>
    } @else {
        <div class="text-center text-slate-400 animate-pulse">
            <i class="fa-solid fa-spinner fa-spin text-2xl"></i>
            <p>Loading store information...</p>
        </div>
    }
</div>
